import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {customerExportData, getCustomerList, schoolExportData} from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from '@/utils/index'
import commonData from "@/utils/commonData";
import CommonData from "@/utils/commonData";


@Component({})
export default class SchoolList extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any= []
    tableHeader: any = [
        { filds: 'customerName', cnFilds: '学生名称', isShow: true, id: 1 },
        { filds: 'attendSchool', cnFilds: '就读学校', isShow: true, id: 2 },
        { filds: 'grade', cnFilds: '年级', isShow: true, id: 3 },
        { filds: 'specialized', cnFilds: '专业', isShow: true, id: 4 },
        { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 5 },
        { filds: 'souCourseSchoolBegin', cnFilds: '开课时间', isShow: true, id: 6 },
        { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 7 },
        { filds: 'souTeacherName', cnFilds: '教授名称', isShow: true, id: 8 },
    ]
    checkTableRow: any = []
    tableHeadFilter = {
        attendSchool: '',
        gradeList: [],
        specialized :'',
        souCourseName :'',
        souCourseSchoolBegin:'',
        souCourseTypeIdList : [],
        souTeacherName:'',
    }
    page = 1
    limit = 20
    total = 0
    selfTotal = 0

    gradeList = CommonData.gradeList

    loading = false

    menuBtn = menuBtn

    timer = null
    typeList= commonData.projectTypeArray
    createdAt: Date[] | null = null
    exportButtonDisabled = false
    exportHeaderDialogVisible = false

    // computed

    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableData()

    }



    getRowKeys (row: any) {
        return row.id
    }

    async getTableData() {
        this.loading = true

        this.tableHeadFilter.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit }
        await getCustomerList(delNullProperty(obj)).then((res) => {
            const data: any = res
            this.tableData = data.financeOrderList
            this.total = data.allNum

            this.$nextTick(() => {
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            });
            this.loading = false
        }).catch((err) => {
            this.loading = false
        })
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    // 导出
    async exportExcel(keys: string = '') {
        this.exportButtonDisabled = true
        this.tableHeadFilter.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit, keys }
        customerExportData(delNullProperty(obj)).then(()=>{
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    // ClickTableRow(row: any, col: any) {
    //     if (!this.menuBtn(34)) return
    //     if (col.label !== '操作' && row.isReceive === 1) {
    //         const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerInfo?id=' + row.id)
    //         const time = setInterval(() => {
    //             if(win.closed) {
    //                 this.getTableData()
    //                 clearInterval(time)
    //             }
    //         }, 500)
    //     }
    // }

}
